import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const emptyDataState: Types.IntegrationsDataState = {
  availableSystems: [],
  existingSystems: [],
}
const emptyViewState = {
  addMenu: false,
  isFetching: false,
}

export interface SystemCredentialsPayload {
  id: number,
  list_name: string,
  password: string,
  username: string,
  system_id: number,
}

export type AddSystemRequestPayload = Request.RequestOptions<any>
export type AddSystemRequestAction = Request.RequestAction<AddSystemRequestPayload>

type RequestActions = Request.RequestAction<any> & Request.SuccessAction<any>

export const dataReducer =
  (state: any = emptyDataState, action: RequestActions) => {
  switch (action.type) {
    case Request.integrationsApiSuccessConstant(Constants.ADD_SYSTEM):
      return {
        ...state,
        availableSystems: Utils.removeSystem(state.availableSystems, action.requestAction.options.payload),
      }
    case Request.integrationsApiSuccessConstant(Constants.FETCH_AVAILABLE_SYSTEMS):
      return {
        ...state,
        availableSystems: action.payload.response.map(( system: Types.System ) => {
          return {
            ...system,
          }
        }),
      }
    case Request.integrationsApiSuccessConstant(Constants.FETCH_EXISTING_SYSTEMS):
      return {
        ...state,
        existingSystems: action.payload.response.map(( system: Types.System ) => {
          return {
            ...system,
          }
        }),
      }
      case Request.integrationsApiRequestConstant(Constants.UPDATE_SYSTEM):
        return {
          ...state,
          existingSystems: Utils.updateSystem(state.existingSystems, action.options),
        }
      case Request.integrationsApiSuccessConstant(Constants.UPDATE_SYSTEM):
        if (action.payload.response.statusMessage === 'updateStatusFailure') {
          return {
            ...state,
            existingSystems: Utils.updateSystem(state.existingSystems, Utils.reverse(action.requestAction.options)),
          }
        }
    default:
      return state
  }
}

const systemFormReducer = (sourceReducer: any) =>
  (state: Form.State<any>, action: any) => {
    const sourceState = sourceReducer(state, action)
    switch (action.type) {
      case Request.integrationsApiSuccessConstant(Constants.ADD_SYSTEM):
      case Request.integrationsApiErrorConstant(Constants.ADD_SYSTEM):
        return {
          ...sourceState,
          isSaving: false,
        }
        default:
          return sourceState
    }
  }

export const viewReducer =
  (state: any = emptyViewState, action: Actions.FetchExistingSystemsAction) => {
  switch (action.type) {
    case Request.integrationsApiRequestConstant(Constants.FETCH_EXISTING_SYSTEMS):
      return {
        ...state,
        isFetching: true,
      }
    case Request.integrationsApiSuccessConstant(Constants.FETCH_EXISTING_SYSTEMS):
    case Request.integrationsApiErrorConstant(Constants.FETCH_EXISTING_SYSTEMS):
      return {
        ...state,
        isFetching: false,
      }
    case Constants.TOGGLE_ADD_SYSTEM_MENU:
      return {
        ...state,
        addMenu: !state.addMenu,
      }
    default:
      return state
  }
}

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => Constants.emptyModalData,
  requestEvent: Constants.ADD_SYSTEM,
  toggleEvent: Actions.FormConstants[Form.ENTER],
}

const systemModalReducer = (sourceReducer: any) =>
  (state: Modal.State<Types.ModalData>, action: any) => {
    const sourceState = sourceReducer(state, action)
    if (action.type === Request.integrationsApiSuccessConstant(Constants.ADD_SYSTEM) ||
      action.type === Request.integrationsApiSuccessConstant(Constants.UPDATE_SYSTEM)
    ) {
      return {
        ...sourceState,
        isOpen: false,
      }
    } else if (action.type === Modal.closeModalConstant(Constants.ADD_SYSTEM)) {
      return {
        ...sourceState,
        data: {
          ...sourceState.data,
          showAddValidation: false,
        },
      }
    } else {
      return sourceState
    }
  }

export const reducer = Redux.combineReducers({
  data: dataReducer,
  form: systemFormReducer(Form.createReducer(Constants.SYSTEM_CREDENTIALS_FORM)),
  modal: systemModalReducer(Modal.reducer(modalReducerEvent)),
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/integrations/reducer.tsx